<template>
  <div>
    <v-skeleton-loader
      type="table-thead, table-tbody"
      width="100%"
      :loading="loading"
      boilerplate
    >
      <v-container class="prices-list-table pa-0 fill-height" fluid>
        <v-card width="100%" class="fill-height" color="gray10 pa-5">
          <v-row class="fill-height">
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    class="white--text float-left"
                    @click="drawer = true"
                  >
                    {{ $t("transactions.filter") }}
                    <v-icon right dark>
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <!--              Table-->
              <TransactionsTable
                :coin-scales="coinScales"
                :current="page"
                :dataTable="tableRecord"
                :loading="loading"
                :pageSize="pageSize"
                :total="total"
              />
              <v-col class="py-0 my-3" cols="12">
                <v-row justify="center">
                  <v-col class="py-0 text-center" cols="12">
                    <v-pagination
                      class="custom-number-pagination"
                      v-model="page"
                      total-visible="6"
                      @input="changePage"
                      :length="total"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-skeleton-loader>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      width="500px"
      class="pa-5 gray9"
    >
      <v-text-field
        v-model="rangeDate"
        :placeholder="$t('transactions.trxRangeTime')"
        name="fromDate"
        type="text"
        outlined
        hide-details
        id="transaction-time"
        background-color="var(--v-field-base)"
        clearable
        clear-icon="$closeIcon"
      />
      <date-picker
        v-model="rangeDate"
        :format="$i18n.locale === 'fa' ? 'jYYYY/jMM/jDD' : 'YYYY/DD/MM'"
        element="transaction-time"
        :popover="$vuetify.rtl ? 'bottom-right' : 'bottom-left'"
        color="#500fe9"
        :locale="$i18n.locale"
        clearable
        range
      />

      <v-autocomplete
        v-model="coinType"
        :items="coinsList"
        item-text="unit"
        item-value="unit"
        filled
        :placeholder="$t('transactions.crypto')"
        :menu-props="{ bottom: true, offsetY: true }"
        class=""
        outlined
        :no-data-text="$t('common.nodata')"
      ></v-autocomplete>
      <v-select
        :items="recordType"
        :placeholder="$t('transactions.trxType')"
        item-text="locale"
        item-value="status"
        outlined
        :menu-props="{ bottom: true, offsetY: true }"
        v-model="recordValue"
      ></v-select>
      <v-row>
        <v-col>
          <v-btn block text color="primary" @click="queryOrder">
            {{ $t("transactions.search") }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn block color="error" text @click="handleClear">
            {{ $t("transactions.clearFilters") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import TransactionsTable from "@/components/Market/historyOrders/TransactionsTable.vue";
import { MarketMarketService, UserCenterService } from "@/services";
import dayjs from "dayjs";

export default {
  components: { datePicker: VuePersianDatetimePicker, TransactionsTable },
  data() {
    return {
      drawer: false,
      loading: false,
      ordKeyword: "",
      rangeDate: "",
      recordValue: "",
      recordType: [],
      coinsList: [],
      coinScales: {},
      coinType: "",
      pageSize: 10,
      page: 1,
      total: 0,
      tableRecord: []
    };
  },
  created() {
    this.rangeDate = "";
    this.getCoinScales();
    this.getList(this.page);
    this.getAddrList();
    this.getType();
  },
  methods: {
    clearSelect(e, key) {
      e.stopPropagation();
      this[key] = "";
    },
    handleClear() {
      this.rangeDate = "";
      this.coinType = "";
      this.recordValue = "";
      this.getList(this.page);
      this.value = false;
    },
    changePage(pageindex) {
      this.page = pageindex;
      this.getList(this.page);
    },
    queryOrder() {
      try {
        this.page = 1;
        this.getList(this.page);
        this.value = false;
      } catch (ex) {
        this.$toast.error(this.$t("transactions.selectRangeTime"));
        return;
      }
    },
    getAddrList() {
      //get address
      UserCenterService.getCoinsList().then(response => {
        if (response.data.code === 0 && response.data.data.length > 0) {
          this.coinsList = response.data.data;
        }
      });
    },
    getType() {
      UserCenterService.getTransactionTypes().then(response => {
        if (response.data.code === 0 && response.data.data.length > 0) {
          this.recordType = response.data.data;
        }
      });
    },
    getCoinScales() {
      MarketMarketService.getFrontCoinScales().then(response => {
        this.coinScales = response.data.data;
      });
    },
    getList(pageNo) {
      //get table withdraw
      let memberId = null;
      // this.getLoginStatus && (memberId = this.getMember.id);

      let startTime = this.convertToTimeStamp(this.rangeDate[0] || "");
      let endTime = this.convertToTimeStamp(this.rangeDate[1] || "");

      let symbol = "";
      let type = "";
      this.coinType && (symbol = this.coinType);
      if (this.recordValue == 0 || this.recordValue) {
        type = this.recordValue;
      }
      // this.recordValue!="" || this.recordValue!=undefined && (type = this.recordValue);
      this.loading = true;
      let payload = {
        pageNo: pageNo,
        pageSize: this.pageSize,
        startTime,
        endTime,
        memberId,
        symbol,
        type
      };
      UserCenterService.getAllTransactions(payload)
        .then(response => {
          let transactionsData = response.data.data;
          if (response.data.code === 0) {
            this.loading = false;
            if (transactionsData) {
              this.total = transactionsData.totalPages;
              this.tableRecord = transactionsData.content;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    convertToTimeStamp(time) {
      const miladiDate = dayjs(time, { jalali: true });
      if (miladiDate.isValid()) {
        return miladiDate.valueOf();
      }
      return null;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped></style>
